export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageVisitsResultsDetail.vue?vue&type=template&id=21caa93d&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisitsResultsDetail.vue?vue&type=template&id=21caa93d&
// module id = null
// module chunks = 